var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v(_vm._s(_vm.$t('components.customersSalesInstallments.salesInstallments')))]),(
          _vm.$parent.item.stat == 1 &&
          _vm.$site.salesPayments_allow &&
          (_vm.$user.admin ||
            _vm.$user.role.sales_payments_add)
        )?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":'/salesInstallments/create?customer_id=' + _vm.$route.params.id}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('components.customersSalesInstallments.addition'))+" ")]):_vm._e()],1),_c('indexTable',{attrs:{"searchText":_vm.$t('components.customersSalesInstallments.FindAInstallment'),"withoutCard":true,"emptyTableText":_vm.$parent.$t('components.customersSalesInstallments.thereAreNosalesInstallments'),"filter":{customer_id: _vm.$route.params.id},"emptyTableSubText":_vm.$parent.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"cloumns":[
        { column: 'code', title: _vm.$t('components.customersSalesInstallments.Payment'), type: 'mainLink', sort: true },
        {
          column: 'customer_id',
          title: _vm.$t('components.customersSalesInstallments.customerName'),
          type: 'link',
          to: 'customer',
          sort: true,
          link: true,
        },
        {
          column: 'created_date',
          title: _vm.$t('components.customersSalesInstallments.RegistrationDate'),
          type: 'text',
          sort: true,
        },
        {
          column: 'date',
          title: _vm.$parent.$t('components.customersSalesInstallments.paymentDate'),
          type: 'text',
          sort: true,
        },
        {
          column: 'description',
          title: _vm.$parent.$t('components.customersSalesInstallments.thatsAbout'),
          type: 'text',
          sort: true,
        },
        {
          column: 'total',
          title: _vm.$parent.$t('components.customersSalesInstallments.amount'),
          type: 'text',
          sort: true,
        },
        {
          column: 'paid',
          title: _vm.$t('components.customersSalesInstallments.paid'),
          type: 'text',
          sort: true,
        },
        {
          column: 'stat',
          title: _vm.$t('components.customersSalesInstallments.active'),
          type: 'status',
          sort: true,
          values: [
            { title: _vm.$t('components.customersSalesInstallments.Waiting'), value: 1, color: 'info' },
            { title: _vm.$t('components.customersSalesInstallments.driven'), value: 0, color: 'success' } ],
        },
        {
          column: 'options',
          title: _vm.$parent.$t('components.customersSalesInstallments.settings'),
          type: 'options',
          options: [
            { name: 'show' },
            {
              name: 'edit',
              role:
                _vm.$user.admin ||
                _vm.$user.role.sales_cheques_edit,
            },
            {name: 'link',   role: _vm.$user.admin || _vm.$user.role.sales_cheques_edit, title:_vm.$t('salesInstallments.AddPayment'), icon: 'dollar-sign', link:'/salesInstallmentsPayments/create/'},
            {
              name: 'delete',
              role:
                _vm.$user.admin ||
                _vm.$user.role.sales_cheques_delete,
            } ],
        } ],"deleteText":{
        attention: _vm.$parent.$t('allerts.Attention'),
        areYouReallySureToDeleteTheItem:
          _vm.$parent.$t('allerts.areYouReallySureToDeleteTheItem'),
        close: _vm.$parent.$t('allerts.close'),
        confirm: _vm.$parent.$t('allerts.confirm'),
        loading: _vm.$parent.$t('allerts.loading'),
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }